<template>
  <div class="w-full flex flex-col md:flex-row py-5 border-b border-black-0.1">
    <div class="w-full md:w-1/2 mb-2.5 md:mb-0">
      <p class="md:hidden label mb-2.5">Item</p>
      <p class="font-primary font-extrabold text-blue-brand text-16 tracking-1/4 leading-1">{{ item.name }}</p>
      <p class="font-primary font-normal text-blue-brand text-16 tracking-1/4 leading-1">{{ item.details }}</p>
    </div>
    <div class="w-full md:w-1/2 flex">
      <div class="flex flex-col flex-grow items-center justify-center font-primary font-extrabold text-blue-dark text-20 leading-1">
        <p class="md:hidden label mb-2.5 text-center">Qty</p>
        <p>{{ item.quantity }}</p>
      </div>
      <div class="flex flex-col w-2/5 items-center justify-center font-primary font-extrabold text-blue-dark text-20 leading-1">
        <p class="md:hidden label mb-2.5 text-center">Amount</p>
        <p>{{ (ammount) }}</p>
      </div>
      <div class="flex flex-col w-2/5 items-center justify-center font-primary font-extrabold text-blue-dark text-20 leading-1">
        <p class="md:hidden label mb-2.5 text-center">Total</p>
        <p>{{ total }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPrice } from '../src/Helpers.js';

export default {

  props: {
    item: {
      type: Object,
      required: true,
    },

    currency: {
      type: String,
      required: true,
    },
  },

  computed: {
    ammount() {
      if (this.currency === 'GBP') {
        return `£${this.readablePrice(this.item.amount)}`
      }
      else if (this.currency === 'USD') {
        return `$${this.readablePrice(this.item.amount)}`
      }
    },

    total() {
      if (this.currency === 'GBP') {
        return `£${this.readablePrice(this.item.quantity * this.item.amount)}`
      }
      else if (this.currency === 'USD') {
        return `$${this.readablePrice(this.item.quantity * this.item.amount)}`
      }
    },
  },

  methods: {
    readablePrice(price) {
      return formatPrice(price);
    },
  },
}
</script>
